export function fromEntries(entries) {
    return Object.assign({}, ...entries.map(([key, value]) => ({ [key]: value })));
}
//# sourceMappingURL=from-entries.js.map